import React from 'react';
import {
  string, func, exact, objectOf,
} from 'prop-types';
import styled, { css } from 'styled-components';
import {
  Input, Flex, Typography, Button,
} from '@atoms';

const DiscountSection = ({
  discountTypes,
  onDiscountTypeChange,
  selectedDiscountType,
}) => {
  const discounts = Object.keys(discountTypes).map(type => (
    <TypeButton
      fullWidth
      padding="sm"
      key={type}
      justifyCenter
      itemsCenter
      onClick={onDiscountTypeChange(type)}
      primaryInverted
      primary={type === selectedDiscountType}
    >
      <Typography weight="black" size="xxxs">
        {discountTypes[type].name}
      </Typography>
    </TypeButton>
  ));

  return (
    <Flex column>
      <Flex marginTop="lg">
        {discounts}
      </Flex>
      <InputContainer marginTop="xl3" itemsCenter selfCenter>
        <InputDiscount
          value={discountTypes[selectedDiscountType].inputValue}
          onChange={discountTypes[selectedDiscountType].inputHandler}
        />
        {selectedDiscountType !== 'price' && (
          <Typography weight="bold" size="xl">Off</Typography>
        )}
      </InputContainer>
    </Flex>
  );
};

const InputContainer = styled(Flex)`
  width: 45%;
`;

const TypeButton = styled(Button.Rectangular)`
  ${({ theme: { spacing } }) => css`
    &:not(:last-of-type) {
      margin-right: ${spacing.sm};
    }
  `}
`;

const InputDiscount = styled(Input)`
  ${({ theme: { color, spacing, typography } }) => css`
    border: 0px;
    border-radius: 0px;
    padding: ${spacing.xxs};
    border-bottom: 1px solid ${color.black};
    font-weight: ${typography.weight.bold};
  `}
`;

DiscountSection.propTypes = {
  discountTypes: objectOf(
    exact({
      name: string,
      inputValue: string,
      inputHandler: func,
    }),
  ).isRequired,
  onDiscountTypeChange: func.isRequired,
  selectedDiscountType: string.isRequired,
};

export default DiscountSection;
